export default "__VITE_PUBLIC_ASSET__7ef8f068__"